import { changeCurrentVariant } from 'shared/store/product/action';
import { SIZE_CHART_LIST } from '@nykaa/size-chart-shared/constants';


interface ClickSizeProps {
  setSelectedOption: Function;
  dispatch: Function;
  id: string;
}
interface UnselectVariantProps {
  setSelectedOption: Function;
}
export const handleClickSizeSelect = ({ id, setSelectedOption, dispatch }: ClickSizeProps) => {
  if (document) {
    const sizeList = document.getElementById(SIZE_CHART_LIST);
    if (sizeList) {
      sizeList.style.height = '68%';
    }
  }
  setSelectedOption(id);
  dispatch(changeCurrentVariant(id));
};

export const unSelectVariant = ({ setSelectedOption }: UnselectVariantProps) => {
  if (document) {
    const sizeList = document.getElementById('SizeList');
    if (sizeList) {
      sizeList.style.height = '90%';
    }
  }
  setSelectedOption('');
};
